import { Injectable } from '@angular/core';
import { EmailLog } from '@osos/shared/api';
import { EmailLogPresenterModel } from '@osos/shared/types';
import { ParserBase } from '../../../bases/parser/parser-base';

@Injectable()
export class EmailParserV1Service extends ParserBase<
  EmailLog,
  EmailLogPresenterModel
> {
  constructor() {
    super(EmailLog, EmailLogPresenterModel, 1);
  }

  getPresenterModel(model: Partial<EmailLog>): EmailLogPresenterModel {
    return {
      id: model.id,
      from: model.from,
      to: model.to,
      cc: model.cc,
      bcc: model.bcc,
      subject: model.subject,
      body: model.body,
      messageId: model.messageId,
      generatedAt: model.generatedAt,
      timestamp: model.timestamp,
      status: model.status,
      errorMessage: model.errorMessage,
      responseCode: model.responseCode,
      relatedTriggerExecutionId: model.relatedTriggerExecutionId,
    };
  }
  getDataModel(presenter: EmailLogPresenterModel): EmailLog {
    return {
      id: presenter.id,
      from: presenter.from,
      to: presenter.to,
      cc: presenter.cc,
      bcc: presenter.bcc,
      subject: presenter.subject,
      body: presenter.body,
      messageId: presenter.messageId,
      generatedAt: presenter.generatedAt,
      timestamp: presenter.timestamp,
      status: presenter.status,
      errorMessage: presenter.errorMessage,
      responseCode: presenter.responseCode,
      relatedTriggerExecutionId: presenter.relatedTriggerExecutionId,
    };
  }
}
